import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 6h12v12H6V6z"
}), 'StopSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StopSharp.js
// module id = 6511
// module chunks = 2